var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"Head"},[_c('img',{attrs:{"src":require("../assets/banner_logo_2d.svg")}})])}]

export { render, staticRenderFns }